import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=53529080&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoadingIndicator.vue"
export default component.exports